import request from '@/utils/request'

export function getIpAddress (id) {
  return request.get(`/ip-addresses/${id}`)
}
